<template>
  <f7-page class="main-report-params-page">
    <f7-navbar title="Asignar parametros al impreso">
      <f7-nav-right>
        <f7-link back>
          <img :src="icClose">
        </f7-link>
      </f7-nav-right>
    </f7-navbar>
    <h3 class="h3-title-report">
      {{ report.Nombre }}
    </h3>

    <form
      ref="form"
    >
      <div class="content-report-params-popup">
        <f7-list>
          <span
            v-for="param in editedParameters"
            :key="param.Id"
          >
            <f7-list-input
              v-if="param.Visible
                && (param.TipoParametro === 'String'
                  || param.TipoParametro === 'Decimal'
                  || param.TipoParametro === 'Int32'
                  || param.TipoParametro === 'Int64'
                  || param.TipoParametro === 'DateTime'
                  || param.TipoParametro === 'Boolean'
                ) && !IsExpecialParam(param.Nombre)"
              :key="param.Id"
              :label="param.Descripcion"
              :type="GetInputType(param.TipoParametro)"
              :placeholder="param.Descripcion"
              :info="param.Comentarios"
              :required="param.SolicitarSiempre"
              validate
              :clear-button="param.TipoParametro !== 'Boolean'"
              :value="param.Valor"
              @input="param.Valor = $event.target.value"
            >
              <option
                v-if="param.TipoParametro === 'Boolean'"
                value="true"
              >
                Si
              </option>
              <option
                v-if="param.TipoParametro === 'Boolean'"
                value="false"
              >
                No
              </option>
            </f7-list-input>

            <div class="margin-top">
              <UCSmartSelectParamsReport
                v-if="param.Visible
                  && param.TipoParametro === 'String'
                  && IsExpecialParam(param.Nombre)"
                :config="GetConfigOfExpecialParam(param.Nombre)"
                :param="param"
                @param-changed="ParamChanged"
              />
            </div>

          </span>
        </f7-list>
      </div>

      <div class="btn-fixed-bottom">
        <f7-button
          @click="SendParameters"
        >
          {{ $t('common.continue') }}
        </f7-button>
      </div>
    </form>
  </f7-page>
</template>

<script>
import UCSmartSelectParamsReport from '@/components/contracts/report/UCSmartSelectParamsReport.vue';
import { HiNotification } from '@/js/common/HINotificationSupport';
import ReportService from '@/js/services/contracts/ReportService';
import icClose from '@/static/icons/ic_close.svg';
import { f7 } from 'framework7-vue';

export default {
  name: 'ReportParamsPage',
  components: {
    UCSmartSelectParamsReport,
  },
  props: {
    report: { type: Object, default: null },
  },
  data() {
    return {
      editedParameters: [],
      icClose,
    };
  },
  mounted() {
    this.editedParameters = this.report.Parametros;
  },
  methods: {
    ParamChanged(newValueParam) {
      this.editedParameters.filter((p) => p.Id === newValueParam.Id).Valor = newValueParam;
    },
    IsExpecialParam(nameParam) {
      if (nameParam === 'CodigoProveedor'
        || nameParam === 'CodigoArticulo'
        || nameParam === 'CodigoPais'
        || nameParam === 'CodigoFamilia') {
        return true;
      }
      return false;
    },
    GetConfigOfExpecialParam(nameParam) {
      switch (nameParam) {
        case 'CodigoProveedor':
          return {
            type: 'farmer',
            method: 'getFarmersFullInfo',
            showValue: 'name',
            returnValue: 'code',
            nameInput: 'Agricultores',
            ref: 'farmer',
          };
        case 'CodigoArticulo':
          return {
            type: 'masterData',
            method: 'getAllVarieties',
            showValue: 'name',
            returnValue: 'code',
            nameInput: 'Articulos',
            ref: 'varieties',
          };
        case 'CodigoPais':
          return {
            type: 'masterData',
            method: 'getAllCountries',
            showValue: 'name',
            returnValue: 'id',
            nameInput: 'Paises',
            ref: 'countries',
          };
        case 'CodigoFamilia':
          return {
            type: 'masterData',
            method: 'getAllFamilies',
            showValue: 'name',
            returnValue: 'code',
            nameInput: 'Familias',
            ref: 'families',
          };
        default:
          return null;
      }
    },
    GetInputType(type) {
      switch (type) {
        case 'String':
          return 'text';
        case 'Decimal':
        case 'Int32':
        case 'Int64':
          return 'number';
        case 'DateTime':
          return 'date';
        case 'Boolean':
          return 'select';
        default:
          return 'text';
      }
    },
    ValidateForm() {
      const { form } = this.$refs;
      if (!form.checkValidity()) {
        return false;
      }
      return true;
    },
    async SendParameters() {
      let reportResult;
      if (!this.ValidateForm()) {
        HiNotification.Alert('Existen parámetros requeridos por completar', 'Información requerida');
        return;
      }
      f7.preloader.show();
      let result = null;
      try {
        result = await ReportService.executeReport(this.report, this.editedParameters);
        if (result.valor) {
          reportResult = result.tag;
          f7.views.main.router.navigate('/display-report/', {
            props: {
              reportTitle: this.report.Nombre,
              pdf: reportResult.FDFDataBase64,
            },
          });
        } else {
          HiNotification.Alert(result.mensaje === null || result.mensaje === '' ? 'No se han encontrado datos para los criterios proporcionados' : result.mensaje);
        }
      } catch {
        HiNotification.Alert('Ocurrio un error al ejecutar el informe');
      }
      f7.preloader.hide();
    },
  },

};
</script>

<style lang="scss">
.main-report-params-page {
  .page-content {
    background: var(--his-whispering-lilac);
  }

  input[type="text"],
  input[type="password"],
  input[type="search"],
  input[type="email"],
  input[type="tel"],
  input[type="url"],
  input[type="date"],
  input[type="month"],
  input[type="datetime-local"],
  input[type="time"],
  input[type="number"],
  select,
  .smart-select .item-content .item-inner,
  textarea {
    border: 1px solid var(--his-silver);
    border-radius: 6px;
    -webkit-border-radius: 6px;
    -moz-border-radius: 6px;
    -ms-border-radius: 6px;
    -o-border-radius: 6px;
  }

  .item-content {
    .item-inner {
      .item-input-wrap {
        input {
          height: 50px;
          padding-left: 10px;
        }

        select {
          height: 50px;
          padding-left: 10px;
        }
      }
    }
  }

  .content-report-params-popup {
    height: calc(100vh - 222px);
    overflow-y: scroll;
  }

  .list {
    list-style: none;
  }

  .h3-title-report {
    padding-left: 20px;
  }
}
</style>
